module.exports = __webpack_public_path__ + "media/images/gift-card-background-9a7450a167e375dc1947191cb511ab23.svg";